import { AppThunkAPI } from "@shared/models/redux";

type CallFolderList = (id: number) => AppThunkAPI<Promise<string[]>>;

export const fetchInitialFoldersList: CallFolderList = (id) => async (_dispatch, _state, extra) => {
  const response = await extra<any[]>(`/documents/v1/CustomDataroom/listFolder/${id}`, {
    method: "get",
  });

  if (response.status === 204) {
    // return { total: 0, results: [] };
  }

  const data = Array.isArray(response.data) ? response.data : [];
  const names = data.flatMap((item) => {
    if (typeof item === "string") {
      return item.trim() ? [item] : [];
    }

    if (!item || typeof item !== "object") return [];

    const nodeType = (item as { nodeType?: string }).nodeType;

    if (nodeType && nodeType !== "P") return [];

    const folderName =
      (item as { folderName?: string; foldername?: string }).folderName ??
      (item as { folderName?: string; foldername?: string }).foldername ??
      "";

    return folderName.trim() ? [folderName] : [];
  });

  return names;
};
